import { AuthService } from '../../../authorization/services';
import * as angular from 'angular';
import { IEmployee, EmployeesService, INote, NotesService, NmbrsService } from '../../../services';

class EmployeesItemController {


    private employee: IEmployee;
    private employeeId: any;
    private employeesService: EmployeesService;
    private activeTabIndex: number;

    private notes: INote[];
    private filteredNotes: INote[];
    private notesService: any;
    private currentNote: any;
    private tags: string[];
    private selectedTag: string;

    private nmbrsEmployee: any;
    private nmbrsEmployeeAddress: any;
    private nmbrsEmployeeBankAccount: any;
    private nmbrsEmployeeFunction: any;
    private nmbrsEmployeeSalary: any;
    private nmbrsEmployeeContract: any;

    private navigator: any;

    constructor(
        EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private NotesService: NotesService,
        private NmbrsService: NmbrsService,
        private AuthService: AuthService,
        private SweetAlert: any,
        private MasterdataService: aboMasterdata.IService,
        private $filter: any,
    ) {
        'ngInject';

        this.notesService = NotesService;
        this.employeesService = EmployeesService;

        this.employeeId = $stateParams['employeeId']

        angular.element(document).ready(() => {
            (<any>$('#notes-table')).dataTable({
                "pageLength": 5,
                "lengthChange": false,
                "searching": false
            });
        });
    }

    public $onInit = () => {
        if (this.AuthService.hasRole("finance")) {
            this.activeTabIndex = 0;
        } else {
            this.activeTabIndex = 1;
        }
        if (this.$stateParams['tab']) {
            this.activeTabIndex = this.$stateParams['tab'];
        }

        if (this.employee && this.employee.nmbrsId) {
            this.NmbrsService.customGet('employee/' + this.employee.nmbrsId).then((result => {
                this.nmbrsEmployee = result;
            }));

            this.NmbrsService.customGet('employeeAddress/' + this.employee.nmbrsId).then((result => {
                this.nmbrsEmployeeAddress = result[0];
            }));

            this.NmbrsService.customGet('employeeBankAccount/' + this.employee.nmbrsId).then((result => {
                this.nmbrsEmployeeBankAccount = result[0];
            }));

            this.NmbrsService.customGet('employeeFunction/' + this.employee.nmbrsId).then((result => {
                this.nmbrsEmployeeFunction = result;
            }));

            this.NmbrsService.customGet('employeeSalary/' + this.employee.nmbrsId).then((result => {
                this.nmbrsEmployeeSalary = result;
            }));

            this.NmbrsService.customGet('employeeContract/' + this.employee.nmbrsId).then((result => {
                this.nmbrsEmployeeContract = result.employeeContracts[0];
            }));
        }

        this.MasterdataService.getItems('NoteTags').then(res => {
            this.tags = res;
        });

        this.filterNotes();
    }

    filterNotes() {
        this.filteredNotes = this.$filter('filter')(this.notes, (note: INote): boolean => {
            if (!!this.selectedTag) {
                return note.tags.indexOf(this.selectedTag) !== -1;
            } else {
                return true;
            }
        });
    }

    submitEmployee() {
        if (this.employee.id == null) {
            this.saveEmployee();
        } else {
            this.employeesService.put(this.employee.id, this.employee);
        }
    }

    saveEmployee() {
        this.employeesService.post(this.employee).then(result => {
            this.$state.go('hr.employees.item', { 'id': result.id });
        });
    }

    deleteEmployee() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze medewerker wilt verwijderen?\n Diensten en declaraties van de medewerker blijven onveranderd!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.employee.inactive = true;
                this.employeesService.put(this.employee.id, this.employee);
                this.$state.go('^.list').then(() => { this.$state.reload(); });
            } else {

            }
        });       
    }

    restoreEmployee() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u de medewerker wilt herstellen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.employee.inactive = false;
                this.employeesService.put(this.employee.id, this.employee);
                this.$state.reload();
            } else {

            }
        });       
    }

    addNoteModal() {
        this.currentNote = null;
        (<any>$('#noteModal')).modal('show');
    }

    updateNoteModal(item) {
        this.currentNote = item;
        (<any>$('#noteModal')).modal('show');
    }

    submitNote(item) {
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.employeeId = this.employee.id;

        if (newNote.id == null) {
            this.notesService.post(newNote).then(result => {
                this.notes.unshift(result);
            });
        } else {
            this.notesService.put(newNote.id, newNote);
        }

        (<any>$('#noteModal')).modal('hide');
    }

    deleteNote(item) {
        this.notes = this.notes.filter(note => note.id !== item.id);

        this.notesService.delete(item.id);
    }

    updateNote(item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    }

    refreshEmployeeNmbrs() {
        this.employeesService.refresh(this.employee.id).then(() => {
            this.$state.reload();
        })
    }

    copyGuid() {
        window.navigator['clipboard'].writeText(this.employee.id);
        alert("De Guid van " + this.employee.displayName + "is gekopieerd");
    }
}

export const employeesItemComponent = {
    bindings: {
        notes: '<',
        userAccount: '<',
        employee: '<',
        history: '<',
        employeeSkills: '<',
        functions: '<'
    },
    controller: EmployeesItemController,
    template: require('./employees.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/employees/employees.item.component.ts